import { render, staticRenderFns } from "./card.vue?vue&type=template&id=5f375ad3&scoped=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"
import style0 from "./card.vue?vue&type=style&index=0&id=5f375ad3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f375ad3",
  null
  
)

export default component.exports